'use client';

import { ArrowUp } from '@/app/components/icons/ArrowUp';
import { MessageIcon } from '@/app/components/icons/MessageIcon';
import { SITE } from '@/app/constants';
import { useLocale } from '@/i18n/routing';
import { PRICING_FAQ, PRICING_FAQ_TITLE } from './constant';

function FaqAccordionItem({ question, answer }: { question: string; answer: string }) {
  return (
    <details className="group">
      <summary className="flex cursor-pointer items-center justify-between rounded-16 px-6 py-5 font-semibold text-[20px] text-white leading-[28px] focus:outline-none sm:rounded-lg sm:px-4 sm:py-4 sm:text-[16px] sm:leading-[24px]">
        <div className="flex items-center">
          <MessageIcon className="mr-3 size-6 text-white sm:mr-2 sm:size-5" />
          {question}
        </div>
        <ArrowUp className="h-6 w-6 transform transition-transform duration-200 group-open:rotate-180 sm:h-5 sm:w-5" />
      </summary>
      <div className="px-6 py-4 sm:px-4">
        <p className="whitespace-pre-line pl-8 text-white opacity-60 sm:pl-6 sm:text-sm">{answer}</p>
      </div>
    </details>
  );
}

export function FAQSection() {
  const locale = useLocale();

  const faqData = PRICING_FAQ[SITE][locale];
  const title = PRICING_FAQ_TITLE[SITE][locale];

  return (
    <section className="py-16 sm:py-10">
      <div className="mx-auto w-full max-w-[1192px] px-6 sm:px-4">
        <h2 className="mb-12 text-center font-semibold text-3xl text-white sm:mb-8 sm:text-2xl">{title}</h2>

        <div className="mx-auto w-full">
          {faqData?.map((faq, index) => (
            <div key={faq.id} className="overflow-hidden">
              <FaqAccordionItem question={faq.question} answer={faq.answer} />
              {index < faqData.length - 1 && <div className="my-4 h-px w-full bg-white bg-opacity-10 sm:my-3" />}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
